import styled from "styled-components";
import { Tabs } from "antd";

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
  }

  .ant-tabs-nav-wrap {
    width: 100%;
  }

  .ant-tabs-tab {
    padding: 12px 0;
    font-weight: 400;
    font-size: 14px;
    color: #5b5b5b;
    transition: all 0.3s;
    font-family: 'Manrope', sans-serif;
    &:hover {
      color: #0C53BB; /* or your desired hover color */
    }
  }

  .ant-tabs-tab:focus,
  .ant-tabs-tab:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  .ant-tabs-tab div {
    outline: none !important;
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
    font-weight: 600;
    color: #0C53BB!important;
    }
  }
`;
